__turbopack_context__.v({
  "deliveryPay__iconsWrapper": "DeliveryPayGrid-module-scss-module__Or0Lyq__deliveryPay__iconsWrapper",
  "deliveryPay__item": "DeliveryPayGrid-module-scss-module__Or0Lyq__deliveryPay__item",
  "deliveryPay__list": "DeliveryPayGrid-module-scss-module__Or0Lyq__deliveryPay__list",
  "deliveryPay__subtitle": "DeliveryPayGrid-module-scss-module__Or0Lyq__deliveryPay__subtitle",
  "deliveryPay__textWrapper": "DeliveryPayGrid-module-scss-module__Or0Lyq__deliveryPay__textWrapper",
  "deliveryPay__title": "DeliveryPayGrid-module-scss-module__Or0Lyq__deliveryPay__title",
  "one_item": "DeliveryPayGrid-module-scss-module__Or0Lyq__one_item",
});
